export const BioInfo = {
    info : "💬 An undergrad Computer Science Engineering student with experience in FullStack development on MERN stack and Interests in AI/ML. Love to participate in Hackathons, ✨Won✨ACM-East India Hackathon 2020 (kolkata)"
};
